import { status, statusText } from '../constants'
import { theme } from '../../../styles/_variables'

const { color } = theme

export const colorSelector = (e) => {
  switch (e) {
    case status.OLD:
      return color.error
    case status.LEAVE:
      return color.error
    case status.LICENSE_EXPIRED:
      return color.warning
    case status.NEWS:
      return color.success
    default:
      return color.charcoalGrey
  }
}

export const textStatusSelector = (e) => {
  switch (e) {
    case status.OLD:
      return statusText.OLD
    case status.LEAVE:
      return statusText.LEAVE
    case status.LICENSE_EXPIRED:
      return statusText.LICENSE_EXPIRED
    case status.NEWS:
      return statusText.NEWS
    default:
      return 'ไม่ระบุ'
  }
}
